import { Link, useNavigate } from 'react-router-dom';
import { getProductBuilderPath } from '../helpers/urlHelper';
import ThumbnailCardUI from './ThumbnailCardUI';
import ThumbnailCardV2 from './ThumbnailCardV2';
import { useProductBuilderActions } from '../hooks/useProductBuilderActions';
import { useInfoDialogaActions } from '../hooks/useInfoDialogaActions';
import { useEffect, useState } from 'react';
import { windowOpen } from '../helpers/jsHelper';
import { CURATOR_PRODUCT_BUILDER_ROUTE, PLANS_ROUTE } from '../constants/routePathConstants';
import { getProductBuilderJson } from '../components/admin/curator/ProductBuilderComponents/commonHelper';
import Loader from './Loader';
import { useMattressBuilderPermission } from '../components/admin/curator/ProductBuilderComponents/useMattressBuilderPermission';
import { createNewMattress } from '../components/admin/curator/ProductBuilderComponents/userPilotEventsMattressBuilder';

export const ThumbnailCardProductBuilder = ({
  data,
  size,
  fullWidth,
  onSelect,
  selected,
  hideFavourite,
  onDelete,
  customActions,
  designV2,
  onDuplicatePass,
  isCollectionItem,
  isSharedItem,
  refetchData,
  onEdit,
  ...rest
}) => {
  const navigate = useNavigate();
  const { addPermission: canAddMattressBuilder } = useMattressBuilderPermission();
  const {
    onDelete: _onDelete,
    onFavouriteToggle,
    favouriteLoading,
    downloading,
    deleteSucess,
  } = useProductBuilderActions({
    item: data,
    isTemplateCard: rest.isTemplateCard,
  });
  const handleDelete = onDelete || _onDelete;
  const id = data.id;
  const url = getProductBuilderPath(id);
  const { openInfoDialog } = useInfoDialogaActions();
  const thumbnailImage = data?.thumbnail || data?.thumb;
  const [loading, setLoading] = useState(false);

  useEffect(() => {
    if (deleteSucess) refetchData();
  }, [deleteSucess]);

  onEdit = async (eventName) => {
    const json = await getProductBuilderJson({ ...data, setLoading });
    createNewMattress({
      id: data.id,
      name: data.name,
      ctaType: eventName || 'Card Thumbnail',
    });
    // Navigate to the product builder route, replacing the ':id' placeholder with the new builder's ID.
    // Pass the builder data in the state for the next component to access.
    navigate(CURATOR_PRODUCT_BUILDER_ROUTE.replace(':id', data?.id).replace('*', ''), {
      state: {
        data: {
          ...data,
          data: {
            ...data?.data,
            json_data: json,
          },
        },
      },
    });
  };

  const titleProps = {
    as: Link,
    to: url,
    onClick: (e) => {
      e.preventDefault();
      onEdit('Card Title');
    },
  };

  const checkForAdd = () => {
    if (!canAddMattressBuilder) {
      openInfoDialog({
        title: 'Subscription expired!',
        description:
          'Access to this file is currently restricted as your Mattress builder subscription has expired. Renew now to pick up where you left off and continue enjoying uninterrupted service',
        buttonText: 'Resume Access',
        onButtonClick: () => {
          windowOpen(PLANS_ROUTE, '_blank');
        },
      });
    }
  };

  return (
    <>
      {loading ? (
        <div
          style={{
            position: 'fixed',
            top: 0,
            left: 0,
            zIndex: 2000,
            background: 'rgba(0,0,0,0.3)',
            height: '100vh',
            width: '100vw',
          }}>
          <Loader loading={loading} />
        </div>
      ) : null}
      <div onClick={() => checkForAdd()}>
        <div className={`${!canAddMattressBuilder ? 'pe-none' : ''}`}>
          {designV2 ? (
            <>
              <ThumbnailCardV2
                onFavouriteChange={onFavouriteToggle(data)}
                onSelect={onSelect}
                selected={selected}
                isFavourite={data.is_favourite}
                hideFavourite={hideFavourite}
                favouriteLoading={favouriteLoading}
                titleProps={titleProps}
                id={data?.id}
                data={{
                  ...data,
                  member_details: data?.created_by_details || rest?.originalData?.member_details,
                }}
                name={data?.name}
                thumbnail={thumbnailImage}
                images={data?.images}
                date={data.updated_at}
                showMenu
                showCheckbox
                isFavouriteIcon
                onEdit={() => onEdit('Edit 3 Dot')}
                onCardClick={() => onEdit('Card Thumbnail')}
                onDelete={handleDelete}
                customActions={customActions}
                downloadLoading={downloading}
                fullWidth={fullWidth}
                // redirect={true}
                // redirectTarget="_self"
                // redirectURL={`${getProductBuilderPath(data.id)}`}
                userCard={true}
                {...rest}
              />
            </>
          ) : (
            <ThumbnailCardUI
              key={id}
              id={id}
              onEdit={() => onEdit('Edit 3 Dot')}
              to={rest.isTemplateCard ? '' : url}
              thumbnail={thumbnailImage}
              images={data?.images}
              name={data.name}
              isFavourite={data.is_favourite}
              favouriteLoading={favouriteLoading}
              date={data.updated_at}
              onDelete={handleDelete}
              onFavouriteChange={onFavouriteToggle(data)}
              customActions={customActions}
              size={size}
              titleProps={titleProps}
              downloadLoading={downloading}
              fullWidth={fullWidth}
              onSelect={onSelect}
              selected={selected}
              hideFavourite={hideFavourite}
              data={data}
              {...rest}
            />
          )}
        </div>
      </div>
    </>
  );
};
